export enum StatusEnum { // Used For Bom Items Status and GRN
    OPEN = 'OPEN',
    //*  IN_PROGRESS not in use.
    IN_PROGRESS = 'IN_PROGRESS',
    PO = 'PO',
    GRN = 'GRN',
    CLOSED = 'CLOSED',
    ASSIGNED = 'ASSIGNED',
    CANCELLED = 'CANCELLED'
}